import { bffRetailMedia } from '~/middlewares/axios'

type BudgetPacingImpactResponse = {
  remaining_cycle_allocation: number
  new_daily_budget: number
  remaining_days: number
}

export const getBudgetPacingImpactService = (
  campaignId: string,
  dailyBudget: number
) =>
  bffRetailMedia.post<BudgetPacingImpactResponse>(
    `/campaign/budget-pacing-impact/${campaignId}`,
    { daily_budget: dailyBudget }
  )
